import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await postSession(session_id);
        setUser(user);
        // Clear hash and go to dashboard
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-ink-500 mb-3">Securing your session</div>
        <div className="h-1 w-64 bg-ink-100 overflow-hidden">
          <div className="h-full w-1/2 bg-safety animate-scan" />
        </div>
      </div>
    </div>
  );
}
